import {UserCarePlanItem} from "../user-care-plan-item.model";
import {GenericDgSearchResults} from "./generic.dg-search-results.model";

export class UserCarePlanItemDgSearchResults extends GenericDgSearchResults {
  public results: UserCarePlanItem[];

  constructor(total: number, results: UserCarePlanItem[], csrfToken: string) {
    super();
    this.total = total;
    this.results = results;
    this.csrfToken = csrfToken;
  }
}

